import { Button, Tooltip, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import {
  ManualValveReport,
  SafetyValveReport,
} from "@/reports/types/SafetyValveReport";
import {
  createDefaultSafetyValveReportValuesFromCopy,
  createDefaultManualValveReportValuesFromCopy,
} from "@/reports/utils/report";
import useNetwork from "@/stores/network";
import { ReportType } from "@/reports/types/Api";

type CopyReportButtonProps = {
  values: SafetyValveReport | ManualValveReport;
  reportType: ReportType;
};

const CopyReportButton = ({ values, reportType }: CopyReportButtonProps) => {
  const { location } = useParams();
  const navigate = useNavigate();

  const { online } = useNetwork();

  return (
    <Tooltip title="Create a new report with autofill based on this report">
      <Button
        disabled={!online}
        onClick={() => {
          if (reportType === "SAFETY_VALVE") {
            navigate("/safety-valve-reports/new", {
              state: {
                location,
                copyReportValues: createDefaultSafetyValveReportValuesFromCopy(
                  values as SafetyValveReport
                ),
              },
            });
          } else if (reportType === "MANUAL_VALVE") {
            navigate("/manual-valve-reports/new", {
              state: {
                location,
                copyReportValues: createDefaultManualValveReportValuesFromCopy(
                  values as ManualValveReport
                ),
              },
            });
          }

          message.success("Report copied");
        }}
      >
        Copy Report
      </Button>
    </Tooltip>
  );
};

export default CopyReportButton;
